import React from 'react'
import TabsProvider from '../../tabs-provider'

const ShowInstitution = ({ params: { institutionId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
// @ts-ignore
      location={location}
      tabs={[
        {
          label: 'Edit Institution',
          path: `/membership/institutions/${institutionId}/edit`
        },
        {
          label: 'Contacts',
          path: `/membership/institutions/${institutionId}/contacts`
        },
        {
          label: 'Sub Accounts',
          path: `/membership/institutions/${institutionId}/sub-accounts`
        },
        {
          label: 'Account Holders',
          path: `/membership/institutions/${institutionId}/account-holders`
        },
        {
          label: 'Analytics',
          path: `/membership/institutions/${institutionId}/analytics`
        },
        {
          label: 'Notes',
          path: `/membership/institutions/${institutionId}/notes`
        },
        {
          label: 'Schools & Colleges',
          path: `/membership/institutions/${institutionId}/schools`
        },
        {
          label: 'Survey',
          path: `/membership/institutions/${institutionId}/survey`
        },
        {
          label: 'Whitelabel',
          path: `/membership/institutions/${institutionId}/whitelabel`
        }
      ]}
    />
    {children}
  </div>
)

export default ShowInstitution
